import React, { useState } from "react";
import "./frozen.scss";

const AllFrozen = () => {
  // State to handle which images to show in the popup
  const [popupImages, setPopupImages] = useState(null);

  const closePopup = () => setPopupImages(null);

  // Scroll to section function
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <div className="__fw" style={{ paddingBottom: "10px", paddingTop: "10px" }}>
      {/* Popup Overlay */}
      {popupImages && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
            padding: "20px",
          }}
          onClick={closePopup}
        >
          <div
            style={{
              backgroundColor: "#fff",
              padding: "20px",
              borderRadius: "8px",
              position: "relative",
              maxWidth: "90%",
              maxHeight: "90%",
              overflowY: "auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <button
              onClick={closePopup}
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                cursor: "pointer",
              }}
            >
              ✕ Close
            </button>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "10px",
                marginTop: "20px",
              }}
            >
              {popupImages.map((img, index) => (
                <img
                  key={index}
                  src={img}
                  alt="Nutrition Facts"
                  style={{ width: "100%", height: "auto" }}
                />
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Brand Navigation Buttons */}
      <div style={{ paddingBottom: "10px", paddingTop: "10px" }}>
        <strong
          style={{
            textTransform: "uppercase",
            letterSpacing: "3px",
            fontWeight: "400",
          }}
        >
          Now Available On{" "}
        </strong>
      </div>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          marginBottom: "30px",
          padding: "15px",
          backgroundColor: "#f5f5f5",
          borderRadius: "10px",
          flexWrap: "wrap",
        }}
      >

        <button
          onClick={() => scrollToSection("spinneys-section")}
          style={{
            padding: "12px 24px",
            fontSize: "16px",
            fontWeight: "600",
            backgroundColor: "#fff",
            border: "2px solid #ddd",
            borderRadius: "8px",
            cursor: "pointer",
            transition: "all 0.3s ease",
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = "#f0f0f0";
            e.target.style.transform = "translateY(-2px)";
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = "#fff";
            e.target.style.transform = "translateY(0)";
          }}
        >
          Spinneys
        </button>

      </div>



      {/* Spinneys Section */}
      <div id="spinneys-section">
        <div className="logo_wrp" style={{ backgroundColor: "#124634" }}>
          <img src={require("../../img/sp_logo.png")} alt="" />
        </div>

        <div className="bd-grid ">
          {/* Product 1 */}
          <div>
            <a
              href="https://www.spinneys.com/en-ae/catalogue/rhutab-chocodate-milk-roasted-almonds-200g_85691/"
              className="card__icon"
            >
              <article className="card">
                <div className="card__img">
                  <img src={require("../../img/01.avif")} alt="" />
                </div>
                <div className="card__precis">
                  <div
                    style={{
                      width: "100%",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <small style={{ fontSize: "13px" }}>
                      Frozen Rhutab Dates
                    </small>
                    <span className="card__preci card__preci--now">
                      Milk Chocolate
                    </span>
                  </div>
                  <div class="buy-btn">Buy Now</div>
                </div>
              </article>
            </a>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <small
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#007bff",
                }}
                onClick={() =>
                  setPopupImages([
                    require("../../img/01_1.avif"),
                    require("../../img/01_2.avif"),
                  ])
                }
              >
                Nutrition Facts
              </small>
            </div>
          </div>
          {/* Product 2 */}
          <div>
            <a
              href="https://www.spinneys.com/en-ae/catalogue/rhutab-chocodate-dark-roasted-almonds-200g_85692/"
              className="card__icon"
            >
              <article className="card">
                <div className="card__img">
                  <img src={require("../../img/02.avif")} alt="" />
                </div>
                <div className="card__precis">
                  <div
                    style={{
                      width: "100%",
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <small style={{ fontSize: "13px" }}>
                      Frozen Rhutab Dates
                    </small>
                    <span className="card__preci card__preci--now">
                      Dark Chocolate
                    </span>
                  </div>
                  <div class="buy-btn">Buy Now</div>
                </div>
              </article>
            </a>
            <div style={{ textAlign: "center", marginTop: "10px" }}>
              <small
                style={{
                  cursor: "pointer",
                  textDecoration: "underline",
                  color: "#007bff",
                }}
                onClick={() =>
                  setPopupImages([
                    require("../../img/02_01.avif"),
                    require("../../img/02_02.avif"),
                  ])
                }
              >
                Nutrition Facts
              </small>
            </div>
          </div>
        </div>
      </div>


    </div>
  );
};

export default AllFrozen;
